export enum RouterPage {
  Login = 'login',
  LoginByCorporateAccount = 'by-corporate-account',
  LoginCreateAccount = 'create-account',
  All = 'all',
  Chats = 'chats',
  Channels = 'channels',
  Thread = 'threads',
  Schedule = 'schedule',
  Spaces = 'spaces',
  Catalog = 'catalog',
  Hub = 'hub',
  Market = 'market',
  Newsfeed = 'newsfeed',
  AppUpdate = 'app-update',
  LinkExpired = 'link-expired',
  GreetingCard = 'greeting-card',
  Unauthorized = 'unauthorized',
  Calendar = 'calendar',
  Deeplink = 'deeplink',
  Untrusted = 'untrusted',
  Blocked = 'blocked',
}

export enum RouterLink {
  Main = '/',
  Login = `/${RouterPage.Login}`,
  Untrusted = `/${RouterPage.Untrusted}`,
  Blocked = `/${RouterPage.Blocked}`,
  LoginByCorporateAccount = `/${RouterPage.Login}/${RouterPage.LoginByCorporateAccount}`,
  LoginCreateAccount = `/${RouterPage.Login}/${RouterPage.LoginCreateAccount}`,
  Chat = `/${RouterPage.Chats}/:id`,
  AllChatPins = `/${RouterPage.Chats}/:id/all-pins`,
  Channel = `/${RouterPage.Channels}/:id`,
  AllChannelPins = `/${RouterPage.Channels}/:id/all-pins`,
  Space = `/${RouterPage.Spaces}/:id`,
  Newsfeed = `/${RouterPage.Newsfeed}`,
  Catalog = `/${RouterPage.Catalog}`,
  Thread = `/${RouterPage.Thread}/:id`,
  Schedule = `/${RouterPage.Schedule}/:id`,
  ForceUpdate = `/${RouterPage.AppUpdate}`,
  LinkExpired = `/${RouterPage.LinkExpired}`,
  articleEdit = `/${RouterPage.Channels}/:id/article/:messageId`,
  Hub = `/${RouterPage.Hub}`,
  Market = `/${RouterPage.Market}`,
  GreetingCard = `/${RouterPage.GreetingCard}`,
  Unauthorized = `/${RouterPage.Unauthorized}`,
  Calendar = `/${RouterPage.Calendar}`,
  Deeplink = `/${RouterPage.Deeplink}`,
}

export enum RouterParams {
  roomCallChannelId = 'room-call-channel-id',
  permissionType = 'permission-type',
  memberPermissionsId = 'member-permissions-id',
  sessionKey = 'sessionKey',
  popup = 'popup',
  groupId = 'group-id',
  messageId = 'message-id',
  deepLink = 'deepLink',
  invitationUrl = 'invitationUrl',
  allowGuests = 'allowGuests',
  type = 'type',
  entityId = 'entityId',
  parentId = 'parentId',
  expired = 'expired',
  branchMatchId = '_branch_match_id',
  branchReferrer = '_branch_referrer',
  spaceId = 'space-id',
  reconnectKey = 'reconnect-key',
  channelId = 'channelId',
  source = 'source',
}

export enum RouterParamsPopup {
  addMembers = 'add-members',
  article = 'article',
  callPermissionRequests = 'call-permissions-requests',
  callPermissions = 'call-permissions',
  callChangeMemberPermission = 'call-change-member-permission',
  callChangeDefaultPermission = 'call-change-default-permission',
  callSelectMember = 'call-select-member',
  callMemberPermissions = 'call-member-permissions-id',
}

export enum RouterState {
  popup = 'popup',
  url = 'url',
  goBackUrl = 'goBackUrl',
  hasGoBack = 'hasGoBack',
  isBack = 'isBack',
  groupId = 'groupId',
  userId = 'userId',
  usersIds = 'usersIds',
  messageIds = 'messageIds',
  message = 'message',
  messageId = 'messageId',
  files = 'files',
  caption = 'caption',
  channel = 'channel',
  sticker = 'sticker',
  type = 'type',
  fromDeepLink = 'fromDeepLink',
  spaceId = 'spaceId',
  marketId = 'marketId',
  collectionId = 'collectionId',
  focusedMessageId = 'focusedMessageId',
  mediaId = 'mediaId',
  backState = 'backState',
  mediaGallery = 'mediaGallery',
}

export enum RouterStatePopup {
  shareMessageTo = 'share-message-to',
  sticker = 'sticker',
  newUsers = 'new-users',
}

export default {
  link: RouterLink,
  params: RouterParams,
  paramsEnum: {
    popup: RouterParamsPopup,
  },
  state: RouterState,
  stateEnum: {
    popup: RouterStatePopup,
  },
};
